export default [
  {
    id: "1",
    name: "Dining tables and desks",
    slug: "dining-tables-and-desks",
    order: "0"
  },
  {
    id: "2",
    name: "Sideboards and cabinets",
    slug: "sideboards-and-cabinets",
    order: "1"
  },
  {
    id: "3",
    name: "Sofa-end, bedside and coffee tables",
    slug: "sofa-end-bedside-and-coffee-tables",
    order: "3"
  },
  {
    id: "4",
    name: "Hall tables and consoles",
    slug: "hall-tables-and-consoles",
    order: "2"
  }
];
